/**
 * Pre-compiled es messages for NumberInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { decrement: `Merma`, increment: `Aumento` };
